__turbopack_context__.v({
  "Avatar": "RlrONW_Avatar",
  "Content": "RlrONW_Content",
  "Fallback": "RlrONW_Fallback",
  "Image": "RlrONW_Image",
  "Paragraph": "RlrONW_Paragraph",
  "ScrollArea": "RlrONW_ScrollArea",
  "Scrollbar": "RlrONW_Scrollbar",
  "Thumb": "RlrONW_Thumb",
  "Viewport": "RlrONW_Viewport",
  "desc": "RlrONW_desc",
  "footer": "RlrONW_footer",
  "inline": "RlrONW_inline",
  "link": "RlrONW_link",
  "listItem": "RlrONW_listItem",
  "mob": "RlrONW_mob",
  "name": "RlrONW_name",
  "position": "RlrONW_position",
  "root": "RlrONW_root",
  "sub": "RlrONW_sub",
  "subItem": "RlrONW_subItem",
  "time": "RlrONW_time",
  "title": "RlrONW_title",
});
